module.exports = __webpack_public_path__ + "static/liva-veri-sag-bbc2048cff46f53fd1f27038dc148ca2.webp";